/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import PropTypes from 'prop-types';
import React, { useRef, useEffect } from 'react';
import getAllTabElements from '../utils/getAllTabElements.js';

var SidePanelFocusTrap = function SidePanelFocusTrap(_ref) {
  var children = _ref.children,
    internal = _ref.internal;
  var botTabTrap = useRef();
  var container = useRef();
  var hidden = internal && !internal.isOpen;
  var labeledBy = (internal === null || internal === void 0 ? void 0 : internal.labeledBy) || '';
  useEffect(function () {
    var trapFocus = function trapFocus(event) {
      var elements;
      if (event.target === botTabTrap.current) {
        elements = getAllTabElements(container.current);
        if (elements.length > 0) {
          var firstElement = elements[0];
          firstElement.focus();
        }
      }
    };
    document.addEventListener('focusin', trapFocus);
    return function () {
      return document.removeEventListener('focusin', trapFocus);
    };
  }, [botTabTrap, container]);
  return /*#__PURE__*/React.createElement("div", {
    ref: container
  }, children, /*#__PURE__*/React.createElement("span", {
    role: hidden ? '' : 'tab',
    "aria-labelledby": labeledBy,
    ref: botTabTrap,
    tabIndex: hidden ? '-1' : '0'
  }));
};
SidePanelFocusTrap.propTypes = {
  children: PropTypes.node.isRequired,
  internal: PropTypes.shape({
    isOpen: PropTypes.bool,
    labeledBy: PropTypes.string
  })
};
var SidePanelFocusTrap$1 = SidePanelFocusTrap;

export { SidePanelFocusTrap$1 as default };
